import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLineage = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M2.07227 8.13281C1.51998 8.13281 1.07227 7.6851 1.07227 7.13281V2.01953C1.07227 1.46725 1.51998 1.01953 2.07227 1.01953H7.18555C7.73783 1.01953 8.18555 1.46725 8.18555 2.01953V7.13281C8.18555 7.6851 7.73783 8.13281 7.18555 8.13281H2.07227Z",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.07227 22.6797C1.51998 22.6797 1.07227 22.232 1.07227 21.6797V16.5664C1.07227 16.0141 1.51998 15.5664 2.07227 15.5664H7.18555C7.73783 15.5664 8.18555 16.0141 8.18555 16.5664V21.6797C8.18555 22.232 7.73783 22.6797 7.18555 22.6797H2.07227Z",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.8145 8.13281C16.2622 8.13281 15.8145 7.6851 15.8145 7.13281V2.01953C15.8145 1.46725 16.2622 1.01953 16.8145 1.01953H21.9277C22.48 1.01953 22.9277 1.46725 22.9277 2.01953V7.13281C22.9277 7.6851 22.48 8.13281 21.9277 8.13281H16.8145Z",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.18555 4.57812L15.8145 4.57813",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.18555 19.125H22.9277",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.18555 15.5664L15.7174 8.03455",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.0723 15.2695L22.9277 19.125L19.0723 22.9805",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgLineage;
